<template>
  <div>
    <div class="row content-header">
      <div class="content-header-left mb-2 col-md-9 col-12">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <h2 class="content-header-title float-left pr-1 mb-0">
              Expense Entry
            </h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Container Card -->
    <b-card no-body>
      <div class="m-3">
        <b-row>
          <!-- Date picker -->
          <b-col cols="12" md="7">
            <b-row>
              <b-col md="4 p-0 mr-1">
                <label for="example-input">From Date</label>
                <b-form-datepicker
                  id="from-date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    weekday: 'short',
                  }"
                  placeholder="Choose a date"
                  local="en"
                  v-model="search_filter.from_date"
                />
              </b-col>
              <b-col md="4 p-0">
                <label for="example-input">To Date</label>
                <b-form-datepicker
                  id="to-date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    weekday: 'short',
                  }"
                  placeholder="Choose a date"
                  local="en"
                  v-model="search_filter.to_date"
                />
              </b-col>
              <b-col md="2 d-flex align-items-end">
                <b-button @click="getExpenseEntry()" variant="primary ">
                  Filter
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="5"
            class="mt-2 d-flex justify-content-end align-items-center"
          >
            <div>
              <b-form-input
                type="text"
                class="form-control"
                placeholder="Search"
                @input="getExpenseEntry()"
                v-model.trim="search_filter.input_field"
                style="border-radius: 4px"
              />
            </div>
            <b-button
              v-b-modal.add-source
              @click="clearFilter"
              variant="secondary
 			 ml-1"
            >
              Clear
            </b-button>
            <b-button
              v-if="hasPermission('add_expense_entry')"
              :to="{
                name: 'farm-apps-expense-add',
              }"
              variant="primary mr-1 ml-2"
            >
              Add
            </b-button>
            <b-button @click="excelDownload()" variant="warning">
              <feather-icon icon="DownloadIcon" size="16" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div v-if="all_expense && all_expense.total > 0">
        <b-table
          :items="all_expense.data"
          responsive
          :fields="fields"
          show-empty
          empty-text="No matching records found"
          class="position-relative"
        >
          <template #cell(index)="data">
            <div class="ml-1">
              {{ all_expense.from + data.index }}
            </div>
          </template>
          <template #cell(production_type)="data">
            <span v-if="data.item.production_type">{{
              data.item.production_type.name
            }}</span>
            <span v-else>NA</span>
          </template>
          <template #cell(farm)="data">
            <span v-if="data.item.farm">{{ data.item.farm.name }}</span>
            <span v-else>NA</span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <router-link
                v-if="hasPermission('update_expense_entry')"
                class="text-secondary"
                :to="{
                  name: 'farm-apps-expense-edit',
                  params: {
                    expenseId: `${data.item.id}`,
                    query: { hatch_id: `${data.item.hatch_id}` },
                  },
                }"
              >
                <feather-icon icon="EditIcon" size="16"
              /></router-link>
            </div>
          </template>
        </b-table>
        <div class="m-2">
          <b-pagination
            :value="all_expense.current_page"
            :total-rows="all_expense.total"
            :per-page="all_expense.per_page"
            align="right"
            @change="getExpenseEntry"
          >
          </b-pagination>
        </div>
      </div>
      <div v-else class="d-flex flex-column align-items-center py-5">
        <b-img
          :src="
            require('@/assets/images/svg/infographics/no_data_infographic.svg')
          "
          class="mr-2"
        />
        <h4 class="mt-2 Secondary">No expense entry yet</h4>
      </div>
    </b-card>
  </div>
</template>

<script>
import axiosIns from "@/libs/axios";
import { BASE_URL } from "@core/common/constants";
import moment from "moment";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      fields: [
        { key: "index", label: "S.no" },
        "production_type",
        {
          key: "farm",
          label: "Farm Name",
          // formatter: (value, key, item) => {
          //   return value.name;
          // },
        },
        "fuel",
        "labour_sal",
        "litter_cost",
        "other",
        "pol",
        "rent",
        "total_cost",
        "Actions",
      ],
      search_filter: {
        input_field: "",
        to_date: "",
        from_date: "",
      },
      all_expense: {},
    };
  },
  created: function () {
    this.getExpenseEntry();
  },

  methods: {
    moment() {
      return moment();
    },
    getExpenseEntry(pageNo = 1) {
      let farmId = this.$route.params.farmId;
      let url = `web/farm/${farmId}/getExpense/all`;
      let queryParams = {
        page: pageNo,
      };

      if (this.search_filter.input_field) {
        queryParams.input_field = this.search_filter.input_field;
      }
      if (this.search_filter.to_date) {
        queryParams.to_date = this.search_filter.to_date;
      }
      if (this.search_filter.from_date) {
        queryParams.from_date = this.search_filter.from_date;
      }

      axiosIns
        .get(this.addQueryString(url, queryParams))
        .then((response) => {
          this.all_expense = response.data.all_expense;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              icon: "CoffeeIcon",
              variant: "danger",
              text:
                error.response?.data?.message ||
                error.response?.data?.error ||
                (error.response?.data?.errors
                  ? Object.values(error.response.data.errors).flat().join(", ")
                  : "Something went wrong. Please try again."),
            },
          });
        });
    },

    excelDownload() {
      if (this.search_filter.from_date && this.search_filter.to_date) {
        this.search_filter.from_date = moment(
          this.search_filter.from_date
        ).format("YYYY-MM-DD");
        this.search_filter.to_date = moment(this.search_filter.to_date).format(
          "YYYY-MM-DD"
        );
      }
      let order_filter_data = this.prepareForm(this.search_filter);
      axiosIns
        .post(`web/export-expense-entry`, order_filter_data)
        .then((response) => {
          var tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = response.data.file;
          tempLink.setAttribute("download", response.data.name);
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          this.getSourceList();
        })
        .catch((error) => {
          error.response;
          const data = error.response?.data?.errors;
          data, "data";
          let arr = Object.values(data).flat().toString(",");
          arr, "array";
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              icon: "CoffeeIcon",
              variant: "danger",
              text: arr,
            },
          });
          this.search_filter.to_date = null;
          this.search_filter.from_date = null;
          this.search_filter.input_field == null;
          this.getSourceList();
        });
    },
    clearFilter() {
      this.search_filter.input_field = "";
      this.search_filter.to_date = "";
      this.search_filter.from_date = "";
      this.getExpenseEntry();
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
